<template>
    <tr class="h-auto cursor-pointer"
        :class="{'bg-gray-50' : isArchived}">
        <td @click.prevent="$emit('show-summary-modal')"
            class="px-4 py-2 text-sm font-medium" :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            <div class="mt-2 gap-2 whitespace-nowrap" :class="getTicketReferenceColorStyles(ticket, 'text')">
                <div class="font-medium text-sm -mt-1">
                    <span>{{ ticket.ticket_reference_number }}</span>
                    <span v-if="ticket.status==='closed'"> - closed</span>
                </div>
                <div class="font-normal">
                    {{ ticket.logged_at }}
                </div>
                <div class="font-normal">
                    {{ ticket.resolved_at ? ticket.resolved_at : "Unresolved" }}
                </div>
            </div>
        </td>
        <td @click.prevent="$emit('show-summary-modal')"
            class="group whitespace-nowrap py-2 px-3 text-sm font-normal hidden md:table-cell" :class="[isArchived ? 'text-gray-400' : 'text-gray-900']">
            <div class="hidden md:table-cell">
                <div class="font-medium"
                     :class="[isArchived ? 'text-gray-400' : 'text-indigo-600']"
                     v-if="ticket.primary_tenant">{{ ticket.primary_tenant.full_name }}
                </div>

                <div class="inline-block font-medium" :class="[isArchived ? 'text-gray-400' : 'text-gray-600']">
                    {{ ticket.service_provider ? ticket.service_provider.name + "(" + ticket.service_provider.type + ")" : "No service provider" }}
                </div>
            </div>
        </td>
        <td @click.prevent="$emit('show-summary-modal')"
            class="whitespace-nowrap px-3 py-2 text-sm font-normal">
            <div class="inline-block" :class="[isArchived ? 'text-gray-400' : 'text-gray-900 font-medium']">
                <span v-if="ticket.archived_at" class="mr-2 rounded px-1.5 py-0.5 bg-gray-200 text-gray-500 font-medium text-xs">
                    archived
                </span>

                {{ ticket.phase ? ticket.phase.name : "No Phase" }}
            </div>
            <div class="line-clamp-1 whitespace-normal" :class="[isArchived ? 'text-gray-400' : 'text-gray-600']">{{ ticket.description }}</div>
        </td>

        <td class="flex items-center justify-end px-3 py-4 hidden md:table-cell md:px-4 md:text-right">
            <button class="font-medium"
                    :class="[isArchived ? 'text-gray-400 hover:text-gray-300' : 'text-indigo-600 hover:text-indigo-500']"
                    @click.prevent="openTicketInNewTab(ticket.id)">View
            </button>
        </td>
    </tr>
</template>

<script>
import TicketStyles from "../../mixins/ticket-styles";

export default {
    name: "ticket-row-in-list-for-asset",
    mixins: [TicketStyles],
    props: ["ticket"],
    computed: {
        isArchived () {
            return this.ticket.archived_at !== null;
        },
        isResolved () {
            return this.ticket.resolved_at !== null;
        },
        isHovered () {
            return false;
        },
    },
    methods: {
        openTicketInNewTab (ticketId) {
            window.open(`/tickets/${ticketId}`, "_blank");
        }
    }
};
</script>

<style scoped>

</style>
